"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserIp = exports.getUserCountryCode = exports.checkIfUserRequiresCookieConsent = exports.decodeCloudflareGeoHeader = void 0;
const header_1 = require("../constants/header");
const country_1 = require("../internationalization/enums/country");
const region_1 = require("../internationalization/region");
const decodeCloudflareGeoHeader = (value) => {
    if (value === undefined) {
        return "NA";
    }
    const joined = Array.isArray(value) ? value.join(",") : value;
    return Buffer.from(joined, "latin1").toString("utf8");
};
exports.decodeCloudflareGeoHeader = decodeCloudflareGeoHeader;
const getSingleHeaderValue = (value) => Array.isArray(value) ? value[0] : value;
const checkIfUserRequiresCookieConsent = (headers) => {
    const country = getSingleHeaderValue(headers?.[header_1.CloudFlareCountryKey]);
    if (header_1.COOKIE_CONSENT_REQUIRED_COUNTRY_CODES.includes(country)) {
        return true;
    }
    if (country !== country_1.CountryCode.CA) {
        return false;
    }
    const region = getSingleHeaderValue(headers?.[header_1.CloudFlareRegionKey]);
    return (0, region_1.isQuebec)(country_1.CountryCode.CA, (0, region_1.resolveRegionCode)(country_1.CountryCode.CA, region));
};
exports.checkIfUserRequiresCookieConsent = checkIfUserRequiresCookieConsent;
const getUserCountryCode = (headers) => headers?.[header_1.CloudFlareCountryKey];
exports.getUserCountryCode = getUserCountryCode;
const getUserIp = (headers) => headers?.[header_1.CloudFlareConnectingIp];
exports.getUserIp = getUserIp;
